import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import Link from '../Link';
import s from './Hero.css';

// Generic marketing hero: eyebrow + H1 + subtitle + up to two CTAs + optional trailing slot
// (e.g. an inline SVG illustration). No page-specific copy lives here — everything comes via props.
function Hero({
  eyebrow,
  title,
  subtitle,
  primaryLabel,
  primaryTo,
  secondaryLabel,
  secondaryTo,
  badges,
  children,
}) {
  return (
    <section className={s.hero}>
      <div className={s.wrap}>
        <div className={s.copy}>
          {eyebrow ? <span className={s.eyebrow}>{eyebrow}</span> : null}
          <h1 className={s.h1}>{title}</h1>
          {subtitle ? <p className={s.sub}>{subtitle}</p> : null}
          {(primaryLabel || secondaryLabel) && (
            <div className={s.ctas}>
              {primaryLabel ? (
                <Link to={primaryTo} className={s.btnPrimary}>{primaryLabel}</Link>
              ) : null}
              {secondaryLabel ? (
                <Link to={secondaryTo} className={s.btnSecondary}>{secondaryLabel}</Link>
              ) : null}
            </div>
          )}
          {badges && badges.length > 0 && (
            <ul className={s.badges}>
              {badges.map((b) => (
                <li key={b} className={s.badge}>
                  <svg viewBox="0 0 24 24" aria-hidden="true" className={s.badgeCheck}>
                    <path d="M20 6 9 17l-5-5" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  {b}
                </li>
              ))}
            </ul>
          )}
        </div>
        {children ? <div className={s.art}>{children}</div> : null}
      </div>
    </section>
  );
}

export default withStyles(s)(Hero);
